import { ActionReducerMap } from "@ngrx/store";
import { authenticationReducer } from "./Authentication/authentication.reducer";
import { LayoutState, layoutReducer } from "./layouts/layouts.reducer";
import { AuthenticationState } from "./Authentication/auth.models";
import { profileReducer } from "./Profile/profile.reducer";
import { userRecordReducer, UserRecordsState } from "./Users/users.reducer";
import { roleRecordReducer, RoleRecordsState } from "./Roles/roles.reducer";
import { permissionRecordReducer, PermissionRecordsState } from "./Permissions/permissions.reducer";
import { EmailTemplateRecordReducer, EmailTemplateRecordsState } from "./EmailTemplate/email-template.reducer";
import { TagRecordsState, TagsRecordReducer } from "./Tags/tags.reducer";
import { FaqsRecordReducer, FaqsRecordsState } from "./Faqs/faqs.reducer";
import { AccessRecordReducer, AccessRecordsState } from "./Access/access.reducer";
import { ChangelogRecordReducer, ChangelogRecordsState } from "./Changelog/changelog.reducer";
import { ManualsRecordReducer, ManualsRecordsState } from "./Manuals/manuals.reducer";
import { TranslationsRecordsState, TranslationssRecordReducer } from "./Translations/translations.reducer";
import { ProductRecordsState, ProductsRecordReducer } from "./Product/product.reducer";
import { ChangelogVersionRecordReducer, ChangelogVersionRecordsState } from "./ChangelogVersion/changelog-version.reducer";

export interface RootReducerState {
    layout: LayoutState;
    auth: AuthenticationState;
    profile: AuthenticationState;
    userRecords: UserRecordsState;
    rolesList: RoleRecordsState;
    permissionsList: PermissionRecordsState;
    emailTemplateRecords: EmailTemplateRecordsState;
    tagRecords: TagRecordsState;
    faqsRecords: FaqsRecordsState;
    accessRecords: AccessRecordsState;
    changelogRecords: ChangelogRecordsState;
    manualsRecords: ManualsRecordsState;
    translationsRecords: TranslationsRecordsState;
    productRecords: ProductRecordsState;
    changelogVersionRecords: ChangelogVersionRecordsState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
    layout: layoutReducer,
    auth: authenticationReducer,
    profile: profileReducer,
    userRecords: userRecordReducer,
    rolesList: roleRecordReducer,
    permissionsList: permissionRecordReducer,
    emailTemplateRecords: EmailTemplateRecordReducer,
    tagRecords: TagsRecordReducer,
    faqsRecords: FaqsRecordReducer,
    accessRecords: AccessRecordReducer,
    changelogRecords: ChangelogRecordReducer,
    manualsRecords: ManualsRecordReducer,
    translationsRecords: TranslationssRecordReducer,
    productRecords: ProductsRecordReducer,
    changelogVersionRecords: ChangelogVersionRecordReducer,
}